<mat-icon *ngIf="icon" class="size-16">{{ icon }}</mat-icon>

<ng-content></ng-content>
